import { IIdsRequest } from "../../model/request/IIdsRequest";
import { IDongBoHinhThucThiRequest } from "../../model/request/tct/IDongBoHinhThucThiRequest";
import { IMonThiAddLopTinChiRequest } from "../../model/request/tct/IMonThiAddLopTinChiRequest";
import { IMonThi } from "../../model/respone/tct/IMonThi";
import { apiClient } from "../apiClient";
import { DOT_THI_API } from "./dotThiApi";

export const MON_THI_API = "mon-thi";
export const monThiApi = {
  SelectAll: () => apiClient.get(`${MON_THI_API}`),
  SelectByDot: (dotThiId: number) => apiClient.get(`${DOT_THI_API}/${dotThiId}/mon-thi`),
  Insert: (payload: IMonThi) => apiClient.post(`${MON_THI_API}`, payload),
  Update: (payload: IMonThi) => apiClient.put(`${MON_THI_API}`, payload),
  Updates: (payload: IMonThi[]) => apiClient.put(`${MON_THI_API}/updates`, payload),
  Delete: (payload: IIdsRequest) => apiClient.post(`${MON_THI_API}/deletes`, payload),
  AddLopTinChi: (payload: IMonThiAddLopTinChiRequest) => apiClient.post(`${MON_THI_API}/lop-tin-chi`, payload),
  AddMonThi: (payload: IMonThi[]) => apiClient.post(`${MON_THI_API}/inserts`, payload),
  DongBoHinhThucThi: (payload: IDongBoHinhThucThiRequest) => apiClient.post(`${MON_THI_API}/dong-bo-hinh-thuc-thi`, payload),
  ReadAndValidateImportData: (payload: any) => apiClient.post(`${MON_THI_API}/import/read-and-validate`, payload),
  Import: (payload: any) => apiClient.post(`${MON_THI_API}/import`, payload),
};
